class Counter {
  constructor() {
    this.counter = document.querySelector('.js-counter');

    this.data = {
      number: parseInt(this.counter.getAttribute('data-count'), 10),
      fps: 30
    };

    this.state = {
      count: 0
    };

    this.rAF = null;
  }

  count = () => {
    if (this.state.count < this.data.number && this.rAF) {
      this.state.count += 1;
      this.counter.innerHTML = (this.state.count < 10 ? `0${this.state.count}` : this.state.count);
    } else {
      window.cancelAnimationFrame(this.rAF);
      this.rAF = null;
    }
  }

  init = () => {
    if (this.state.number <= 0) return;

    setTimeout(() => {
      this.rAF = window.requestAnimationFrame(this.init);
      this.count();
    }, 1000 / this.data.fps);
  }
}

export default Counter;
